var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConnections01 = function SvgConnections01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "connections-01_svg2__a",
    x1: 27.7,
    x2: 173.84,
    y1: 172.07,
    y2: 25.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#connections-01_svg2__a",
    id: "connections-01_svg2__b",
    x1: 29.94,
    x2: 176.09,
    y1: 174.32,
    y2: 28.17
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#connections-01_svg2__a",
    id: "connections-01_svg2__c",
    x1: 70.54,
    x2: 216.68,
    y1: 214.91,
    y2: 68.77
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#connections-01_svg2__a",
    id: "connections-01_svg2__d",
    x1: 99.02,
    x2: 245.16,
    y1: 243.39,
    y2: 97.25
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#connections-01_svg2__a",
    id: "connections-01_svg2__e",
    x1: 25.68,
    x2: 171.83,
    y1: 170.06,
    y2: 23.91
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#connections-01_svg2__a",
    id: "connections-01_svg2__f",
    x1: -43.51,
    x2: 102.64,
    y1: 100.87,
    y2: -45.28
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#connections-01_svg2__a",
    id: "connections-01_svg2__g",
    x1: -14.97,
    x2: 131.17,
    y1: 129.41,
    y2: -16.74
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#connections-01_svg2__a",
    id: "connections-01_svg2__h",
    x1: 27.81,
    x2: 173.96,
    y1: 172.19,
    y2: 26.04
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#connections-01_svg2__a",
    id: "connections-01_svg2__i",
    x1: 27.77,
    x2: 173.92,
    y1: 172.15,
    y2: 26
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M99.95 37.13c-6.6 0-13.09 1.1-19.29 3.2-1.5.5-2.4 2.2-1.9 3.8s2.2 2.4 3.7 1.9c5.6-1.9 11.49-2.9 17.49-2.9 30.48 0 55.37 25.49 55.37 56.77s-24.79 56.77-55.37 56.77-55.37-25.49-55.37-56.77 9.8-37.78 26.19-48.28c1.4-.9 1.8-2.7.9-4.2-.9-1.4-2.7-1.8-4-1-8.7 5.5-15.89 13.29-20.99 22.39-5.2 9.4-8 20.09-8 30.98 0 34.68 27.49 62.87 61.27 62.87s61.27-28.19 61.27-62.87-27.49-62.87-61.27-62.87v.2Z",
    style: {
      fill: "url(#connections-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.53 46.93c.5.5 1.2.7 1.9.7s1.7-.4 2.3-1.1l19.39-23.99h10.29c1.2 3.9 4.8 6.7 9 6.7 5.2 0 9.5-4.4 9.5-9.7s-4.3-9.7-9.5-9.7-7.8 2.8-9 6.7h-11.69c-.9 0-1.7.4-2.3 1.1l-20.29 25.09c-1 1.3-.9 3.2.4 4.2m42.87-31.19c2 0 3.6 1.7 3.6 3.7s-1.6 3.7-3.6 3.7-3.6-1.7-3.6-3.7 1.6-3.7 3.6-3.7",
    style: {
      fill: "url(#connections-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.4 90.31c-4.2 0-7.8 2.8-9 6.7h-9.9c-1.6 0-2.9 1.3-2.9 3s1.3 3 2.9 3h9.9c1.2 3.9 4.8 6.7 9 6.7s9.5-4.4 9.5-9.7-4.3-9.7-9.5-9.7m0 13.39c-2 0-3.6-1.7-3.6-3.7s1.6-3.7 3.6-3.7S194 98 194 100s-1.6 3.7-3.6 3.7",
    style: {
      fill: "url(#connections-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.4 170.77c-4.2 0-7.8 2.8-9 6.7h-10.29l-19.39-23.99c-1-1.3-2.9-1.5-4.1-.4s-1.4 3-.4 4.2l20.29 25.09c.6.7 1.4 1.1 2.3 1.1h11.69c1.2 3.9 4.8 6.7 9 6.7s9.5-4.4 9.5-9.7-4.3-9.7-9.5-9.7zm0 13.49c-2 0-3.6-1.7-3.6-3.7s1.6-3.7 3.6-3.7 3.6 1.7 3.6 3.7-1.6 3.7-3.6 3.7",
    style: {
      fill: "url(#connections-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.37 153.07c-1.2-1.1-3.1-.9-4.1.4l-19.39 23.99H18.59c-1.2-3.9-4.8-6.7-9-6.7-5.2 0-9.5 4.4-9.5 9.7s4.3 9.7 9.5 9.7 7.8-2.8 9-6.7h11.69c.9 0 1.7-.4 2.3-1.1l20.29-25.09c1-1.3.9-3.2-.4-4.2zM9.5 184.26c-2 0-3.6-1.7-3.6-3.7s1.6-3.7 3.6-3.7 3.6 1.7 3.6 3.7-1.6 3.7-3.6 3.7",
    style: {
      fill: "url(#connections-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 29.24c4.2 0 7.8-2.8 9-6.7h10.29l19.39 23.99c.6.7 1.4 1.1 2.3 1.1s1.3-.2 1.9-.7c1.2-1.1 1.4-3 .4-4.2L32.49 17.64c-.6-.7-1.4-1.1-2.3-1.1H18.5c-1.2-3.9-4.8-6.7-9-6.7-5.2-.1-9.5 4.3-9.5 9.6s4.3 9.7 9.5 9.7zm0-13.5c2 0 3.6 1.7 3.6 3.7s-1.6 3.7-3.6 3.7-3.6-1.7-3.6-3.7 1.6-3.7 3.6-3.7",
    style: {
      fill: "url(#connections-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 109.7c4.2 0 7.8-2.8 9-6.7h9.9c1.6 0 2.9-1.3 2.9-3s-1.3-3-2.9-3h-9.9c-1.2-3.9-4.8-6.7-9-6.7S0 94.6 0 100s4.3 9.7 9.5 9.7m0-13.4c2 0 3.6 1.7 3.6 3.7s-1.6 3.7-3.6 3.7-3.6-1.7-3.6-3.7 1.6-3.7 3.6-3.7",
    style: {
      fill: "url(#connections-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.85 54.12h-9.7c-2.8 0-5.1 2.4-5.1 5.3v6.1c-2.3.7-4.6 1.7-6.7 2.9l-4.2-4.3c-2-2.1-5.3-2.1-7.3 0l-6.9 7c-2 2.1-2 5.4 0 7.5l4.2 4.3c-1.2 2.2-2.1 4.5-2.8 6.9h-6c-2.8 0-5.1 2.4-5.1 5.3v10c0 2.9 2.3 5.3 5.1 5.3h6c.7 2.4 1.6 4.7 2.8 6.9l-4.2 4.3c-1 1-1.5 2.3-1.5 3.7s.5 2.7 1.5 3.7l6.9 7c1 1 2.3 1.5 3.6 1.5s2.7-.5 3.6-1.5l4.2-4.3c2.1 1.2 4.4 2.2 6.7 2.9v6.1c0 2.9 2.3 5.3 5.1 5.3h9.7c2.8 0 5.1-2.4 5.1-5.3v-6.1c2.3-.7 4.6-1.7 6.7-2.9l4.2 4.3c2 2.1 5.3 2.1 7.3 0l6.9-7c1-1 1.5-2.3 1.5-3.7s-.5-2.7-1.5-3.7l-4.2-4.3c1.2-2.2 2.1-4.5 2.8-6.9h6c2.8 0 5.1-2.4 5.1-5.3v-10c0-2.9-2.3-5.3-5.1-5.3h-6c-.7-2.4-1.6-4.7-2.8-6.9l4.2-4.3c2-2.1 2-5.4 0-7.5l-6.9-7c-2-2.1-5.3-2.1-7.3 0l-4.2 4.3c-2.1-1.2-4.4-2.2-6.7-2.9v-6.1c0-2.9-2.3-5.3-5.1-5.3zm10.69 20.59c1.2.8 2.7.6 3.7-.4l5.3-5.4 5.8 6-5.3 5.4c-1 1-1.1 2.6-.4 3.7 1.8 2.9 3.1 6.1 3.8 9.5.3 1.4 1.5 2.4 2.9 2.4h7.5v8.4h-7.5c-1.4 0-2.6 1-2.9 2.4-.7 3.4-2 6.5-3.8 9.5-.7 1.2-.6 2.7.4 3.7l5.3 5.4-5.8 6-5.3-5.4c-1-1-2.5-1.2-3.7-.4-2.8 1.9-5.9 3.2-9.2 3.9-1.3.3-2.3 1.5-2.3 2.9v7.7h-8.2v-7.7c0-1.4-1-2.6-2.3-2.9-3.3-.8-6.4-2.1-9.2-3.9-1.2-.8-2.7-.6-3.6.4l-5.3 5.4-5.8-6 5.3-5.4c1-1 1.1-2.6.4-3.7-1.8-2.9-3.1-6.1-3.8-9.5-.3-1.4-1.5-2.4-2.9-2.4h-7.5v-8.4h7.5c1.4 0 2.6-1 2.9-2.4.7-3.4 2-6.5 3.8-9.5.7-1.2.6-2.7-.4-3.7l-5.3-5.4 5.8-6 5.3 5.4c1 1 2.5 1.2 3.6.4 2.8-1.9 5.9-3.2 9.2-3.9 1.3-.3 2.3-1.5 2.3-2.9v-7.7h8.2v7.7c0 1.4 1 2.6 2.3 2.9 3.3.8 6.4 2.1 9.2 3.9",
    style: {
      fill: "url(#connections-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.75 77.31c-11.19.6-20.39 10.09-20.99 21.59-.3 6.4 2 12.69 6.5 17.29 4.2 4.3 9.8 6.7 15.69 6.7h1.1c1.6 0 2.9-1.5 2.8-3.2 0-1.7-1.5-2.9-3.1-2.9-4.7.2-9.1-1.5-12.39-4.9-3.3-3.4-5-7.9-4.8-12.69.4-8.5 7.2-15.39 15.39-15.89 4.7-.2 9.4 1.7 12.69 5.2 6.7 7.2 4.9 17.89-.6 23.49-1.1 1.2-1.1 3.1 0 4.3 1.2 1.2 3 1.2 4.2 0 3.9-4.1 6.3-9.7 6.6-15.39.3-6.2-1.8-12.09-6-16.49-4.5-4.8-10.69-7.4-17.19-7l.1-.1Z",
    style: {
      fill: "url(#connections-01_svg2__i)"
    }
  }));
};
export default SvgConnections01;